import { Box, Col } from '@opendoor/atoms/box';

interface SpinningGradientProps {
  children: React.ReactNode;
}

const SpinningGradient: React.FC<SpinningGradientProps> = ({ children }) => {
  return (
    <Col className="relative mt-[200px] bg-od-bg-inverse-primary max-md:mt-[100px]">
      <Col className="relative z-[2]">{children}</Col>
      <Box className="absolute inset-0 overflow-visible">
        <Box className="blur">
          <Box className="gradient-mask">
            <Box className="spinning-gradient" />
          </Box>
        </Box>
      </Box>
    </Col>
  );
};

export default SpinningGradient;
